export function Circle(props) {
  return (
    <svg height="90" width="90">
      <circle cx="45" cy="45" r="40" fill={props.color} />
    </svg>
  )
}